import ProductState from "./ProductState";
import { Discount } from "./ProductPageStateSchema";

import * as Util from "../Utils/Util";
import Events from "../Utils/Events";
import Hider from "../Utils/Hider";
import DomFactory from "../Utils/DomFactory";

export default class DiscountBubble {
  private readonly discountBubbleElement: HTMLElement;
  private readonly percentageAmountElement: HTMLElement;
  private readonly promoCodeElement: HTMLElement;

  public constructor(element: HTMLElement) {
    this.discountBubbleElement = element;
    this.percentageAmountElement = Util.findByBindName("discount-bubble-percentage", element) as HTMLElement;
    this.promoCodeElement = Util.findByBindName("discount-bubble-code", element) as HTMLElement;

    Events.on("product-state-change", (s: ProductState) => this.updateDiscount(s));
    Events.fire("product-state-change-request", this);
  }

  private updateDiscount(state: ProductState) {
    const discount: Discount | null = state.quantity.discount;

    if (discount == null || discount.newCustomerOnly || !discount.discountCode) {
      Hider.hide(this.discountBubbleElement);
      return;
    }

    Hider.show(this.discountBubbleElement);
    this.percentageAmountElement.innerHTML = discount.discountSaving;
    this.promoCodeElement.innerHTML = discount.discountCode;
  }

  public static Factory: DomFactory<DiscountBubble> = (e) => new DiscountBubble(e);
}
